import { TextField } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

export function DriverLineForm({ errors, driverLine, Controller, control }) {
  console.log('driverLine', driverLine);

  return (
    <div className="flex flex-row flex-wrap">
      <div className="w-full px-1 py-2">
        <Controller
          name={'name'}
          control={control}
          defaultValue={driverLine ? driverLine.name : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ชื่อแผนก"
              required
              fullWidth
              size={'small'}
              helperText={errors.name && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-2">
        <Controller
          name={'description'}
          control={control}
          defaultValue={driverLine ? driverLine.description : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="รายละเอียด"
              fullWidth
              size={'small'}
              multiline={true}
              helperText={errors.description && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
    </div>
  );
}

DriverLineForm.propTypes = {
  errors: PropTypes.shape({
    name: PropTypes.object,
    description: PropTypes.object,
  }),
  driverLine: PropTypes.object,
  Controller: PropTypes.func,
  control: PropTypes.object,
};

DriverLineForm.defaultProps = {
  driverLine: null,
};

export default DriverLineForm;
